"use strict";
import { Fragment, useRef, useState } from "react";
import { Popover } from "ui/src";
import { MenuContent } from "components/menus/ContextMenuContent";
import { ContextMenuTriggerMode } from "components/menus/types";
import { isMobileWeb } from "utilities/src/platform";
import { useOnClickOutside } from "utilities/src/react/hooks";
export function ContextMenu({
  menuItems,
  isPlacementAbove = false,
  isPlacementRight = false,
  offsetX = 0,
  offsetY = 0,
  triggerMode,
  disabled = false,
  children,
  isOpen,
  closeMenu,
  openMenu
}) {
  const containerRef = useRef(null);
  const triggerContainerRef = useRef(null);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const isLeftClick = triggerMode === ContextMenuTriggerMode.Primary;
  useOnClickOutside(containerRef, () => {
    closeMenu();
  });
  const onContextMenu = (e) => {
    if (disabled) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    openMenu?.();
    const { clientX, clientY } = e;
    setMenuPosition({ x: clientX, y: clientY });
  };
  function getRelativeCoordinates() {
    if (isLeftClick || !triggerContainerRef.current) {
      return { x: 0, y: 0 };
    }
    const rect = triggerContainerRef.current.getBoundingClientRect();
    const relativeX = isPlacementRight ? menuPosition.x - rect.left : menuPosition.x - rect.right;
    const relativeY = menuPosition.y - rect.top - rect.height;
    return {
      x: relativeX,
      y: relativeY
    };
  }
  const { x, y } = getRelativeCoordinates();
  if (disabled || isMobileWeb) {
    return <Fragment>{children}</Fragment>;
  }
  return <Popover
    allowFlip
    open={isOpen}
    strategy="absolute"
    placement={isPlacementAbove ? isPlacementRight ? "top-start" : "top-end" : isPlacementRight ? "bottom-start" : "bottom-end"}
    offset={{
      mainAxis: y + (isPlacementAbove ? -offsetY : offsetY),
      crossAxis: x + (isPlacementRight ? offsetX : -offsetX)
    }}
  >
      {
    /*
      We attach the context menu event handler conditionally:
      - If onLeftClick is true, we use onMouseDown to open the menu on left-click.
      - Otherwise, we use onContextMenu to open the menu on right-click.
      This ensures that left-click events are not blocked from propagating,
      keeping normal click behavior intact.
    */
  }
      <Popover.Trigger onMouseDown={isLeftClick ? onContextMenu : void 0}>
        {
    /* eslint-disable-next-line react/forbid-elements */
  }
        <div ref={triggerContainerRef} onContextMenu={isLeftClick ? void 0 : onContextMenu}>
          {children}
        </div>
      </Popover.Trigger>
      <Popover.Content
    ref={containerRef}
    key={`${menuPosition.x}-${menuPosition.y}`}
    backgroundColor="transparent"
    animation="125ms"
    enterStyle={{
      opacity: 0,
      scale: 0.98,
      transform: [{ translateY: -4 }]
    }}
  >
        <MenuContent items={menuItems} handleCloseMenu={closeMenu} />
      </Popover.Content>
    </Popover>;
}
